export const DETAILS_SUMMARY_QUERY_PARAMS = {
  search: 'dsSearch',
  page: 'dsPage',
  pageSize: 'dsPageSize',
  sort: 'dsSort',
};

export const DETAILS_DELEGATION_QUERY_PARAMS = {
  search: 'ddSearch',
  page: 'ddPage',
  pageSize: 'ddPageSize',
  sort: 'ddSort',
};

export const BUILDING_DETAILS_URL_PARAM_KEYS = [
  ...Object.values(DETAILS_SUMMARY_QUERY_PARAMS),
  ...Object.values(DETAILS_DELEGATION_QUERY_PARAMS),
];

export const DEFAULT_DETAILS_TABLE_FILTER = {
  options: {},
  searchText: '',
  searchPlaceholder: 'Search ...',
};

const compareSortValues = (a, b) => {
  const av = a == null ? '' : String(a);
  const bv = b == null ? '' : String(b);
  const an = Number(a);
  const bn = Number(b);
  if (Number.isFinite(an) && Number.isFinite(bn) && av !== '' && bv !== '') {
    return an - bn;
  }
  return av.localeCompare(bv, undefined, { numeric: true, sensitivity: 'base' });
};

/** Client-side search, sort, and page slice for static building detail tables. */
export const applyClientListState = ({ rows, filter, sortOptions, pagination, searchKeys }) => {
  const searchText = (filter?.searchText || '').trim().toLowerCase();
  let next = Array.isArray(rows) ? rows : [];

  if (searchText) {
    next = next.filter((row) =>
      searchKeys.some((key) =>
        String(row[key] ?? '')
          .toLowerCase()
          .includes(searchText),
      ),
    );
  }

  const activeSort = Object.entries(sortOptions || {}).find(([, dir]) => dir === 1 || dir === -1);
  if (activeSort) {
    const [field, direction] = activeSort;
    next = [...next].sort((a, b) => {
      const cmp = compareSortValues(a[field], b[field]);
      return direction === -1 ? -cmp : cmp;
    });
  }

  const totalItems = next.length;
  const rowsPerPage = Math.max(1, pagination?.rowsPerPage || 12);
  const totalPages = totalItems === 0 ? 0 : Math.ceil(totalItems / rowsPerPage);
  const maxPage = Math.max(0, totalPages - 1);
  const pageNumber = Math.min(Math.max(0, pagination?.pageNumber || 0), maxPage);
  const start = pageNumber * rowsPerPage;

  return {
    pageRows: next.slice(start, start + rowsPerPage),
    totalItems,
    totalPages,
    pageNumber,
  };
};
